import Chart from 'chart.js';
import 'chartjs-plugin-colorschemes';

var ES6Promise = require("es6-promise");

import axios from 'axios';
import {saveAs} from 'file-saver';
import {saveSvgAsPng} from 'save-svg-as-png';
(function ($) {

  "use strict";
  Drupal.behaviors.civicCharts = {
    attach: function (context, settings) {

      $(once('civicCharts', '.chart-wrapper', context)).each(function () {

        ES6Promise.polyfill();

        var iscCharts = [];
        var count;
        var chartWrapper = document.getElementsByClassName('chart-wrapper');
        if (chartWrapper.length > 0 ) {

          for (count = 0; count < chartWrapper.length; count++) {

            var nid = chartWrapper[count].getAttribute('data-nid');

            // Make a request for a user with a given ID
            axios.get('/rest/chart-data/' + nid)
            .then(function (response) {
              var ctx = document.getElementsByClassName('chart-' + response.data.nid);

              var firstChart = document.getElementById(ctx[0].id);
              var chartFilled = firstChart.getAttribute('data-filled');
              var chartStacked = firstChart.getAttribute('data-stacked');
              var dataLineType = firstChart.getAttribute('data-linetype');

              var datasets = [];
              var pie_datasets = [];

              var customColorFunction = function(schemeColors) {
                var customColorScheme = settings.civicCharts.colorscheme;
                // extend the color scheme with own colors
                Array.prototype.push.apply(schemeColors, customColorScheme);
                return schemeColors;
              };

              for (var x = 0; x < response.data.count; x++) {

                if (firstChart.getAttribute('data-combo') === 'true') {
                  datasets[x] = {
                    label: response.data.datalabels[x],
                    fill: chartFilled === 'true' ? true : false,
                    lineTension: 0,
                    data: response.data.dataset[x],
                    type: response.data.combo_columns[x] ? response.data.combo_columns[x] : 'line'
                  };
                }
                else {
                  datasets[x] = {
                    label: response.data.datalabels[x],
                    fill: chartFilled === 'true' ? true : false,
                    lineTension: 0,
                    data: response.data.dataset[x]
                  };
                }

                if (dataLineType === 'dotted') {
                  datasets[x]['borderDash'] = [5, 5];
                }

                pie_datasets[x] = {
                  label: response.data.datalabels[x],
                  data: response.data.dataset[x]
                };
              }

              datasets[0].yAxisID = 'left-y-axis';
              pie_datasets[0].yAxisID = 'left-y-axis';

              if (response.data.count > 1 && firstChart.getAttribute('data-secondaxe') === 'true' ) {
                var secondAxe = {
                  id: 'right-y-axis',
                  type: 'linear',
                  position: 'right',
                  stacked: chartStacked === 'true' ? true : false,
                  scaleLabel: {
                    display: firstChart.getAttribute('data-ysecondlabel') ? true : false,
                    labelString: firstChart.getAttribute('data-ysecondlabel')
                  },
                  ticks: {
                    callback: function(value, index, values) {
                      if (Array.isArray(value)){
                        value[value.length - 1] = chartContainer.getAttribute('data-ysecondprefix') + value[value.length - 1] + chartContainer.getAttribute('data-ysecondsuffix');
                      }
                      else {
                        value = chartContainer.getAttribute('data-ysecondprefix') + value + chartContainer.getAttribute('data-ysecondsuffix');
                      }
                      return value;
                      //return firstChart.getAttribute('data-ysecondprefix') + value + firstChart.getAttribute('data-ysecondsuffix');
                    }
                  },
                };
                datasets[1].yAxisID = 'right-y-axis';
                pie_datasets[1].yAxisID = 'right-y-axis';
              }
              else {
                var secondAxe = {display: false};
              }

              for (var i = 0; i < ctx.length; i++) {

                var chartContainer = document.getElementById(ctx[i].id);
                var tempChart = chartContainer.getContext('2d');
                var chartType =  chartContainer.getAttribute('data-combo') === 'true' && chartContainer.getAttribute('data-stacked') === 'true' ? 'bar' : chartContainer.getAttribute('data-charttype');
                var horizontalBarTicks = '';

                if ( chartType === 'horizontalBar' ) {
                  horizontalBarTicks = {
                    suggestedMin: response.data.min,
                    suggestedMax: response.data.max
                  };
                  secondAxe = {
                    display: false
                  };
                }

                iscCharts[(i+1)*(count+1)] = new Chart(tempChart, {

                  type: chartType,

                  data: {
                    labels: response.data.labelsmultilines,
                    datasets: chartType === 'pie' || chartType === 'doughnut' ? pie_datasets : datasets
                  },

                  options: {
                    scales: {
                      xAxes: [{
                        display: chartType === 'pie' || chartType === 'doughnut' ? false : true,
                        stacked: chartStacked === 'true' ? true : false,
                        scaleLabel: {
                          display: chartContainer.getAttribute('data-xlabel') ? true : false,
                          labelString: chartContainer.getAttribute('data-xlabel')
                        },
                        ticks: horizontalBarTicks ? horizontalBarTicks : {},
                        gridLines: {
                          display: chartType === 'pie' || chartType === 'doughnut' ? false : true
                        }
                      }],
                      yAxes: [{
                        display: chartType === 'pie' || chartType === 'doughnut' ? false : true,
                        id: 'left-y-axis',
                        type: chartType === 'horizontalBar' ? 'category' : 'linear',
                        position:'left',
                        stacked: chartStacked === 'true' ? true : false,
                        scaleLabel: {
                          display: chartContainer.getAttribute('data-ylabel') ? true : false,
                          labelString: chartContainer.getAttribute('data-ylabel')
                        },
                        ticks: {
                          //beginAtZero: true,
                          suggestedMin: response.data.min,
                          suggestedMax: response.data.max,
                          callback: function(value, index, values) {
                            if (Array.isArray(value)){
                              value[value.length - 1] = chartContainer.getAttribute('data-yprefix') + value[value.length - 1] + chartContainer.getAttribute('data-ysuffix');
                            }
                            else {
                              value = chartContainer.getAttribute('data-yprefix') + value + chartContainer.getAttribute('data-ysuffix');
                            }
                            return value;
                            //return chartContainer.getAttribute('data-yprefix') + value + chartContainer.getAttribute('data-ysuffix');
                          }
                        },
                        gridLines: {
                           display: chartType === 'pie' || chartType === 'doughnut' ? false : true
                        }
                      },
                        secondAxe
                      ]
                    },
                    plugins: {
                      colorschemes: {
                        scheme: 'brewer.SetOne3',
                        custom: customColorFunction,
                        reverse: true
                      }
                    }
                  }
                });
              }
            })
            .catch(function (error) {
              console.log(error);
            });
          }

        }

        //Downloads charts
        const downloadBtn = document.getElementsByClassName('chart--donwload');
        if (downloadBtn) {
          for (let i = 0; i < downloadBtn.length; i++) {
            downloadBtn[i].onclick = function(e){
              e.preventDefault();
              const chart = this.getAttribute('data-chart');

              if (chart.indexOf('mapChartContainer') !== -1) {
                const map = document.getElementById(chart).getElementsByClassName('jvectormap-container')[0].getElementsByTagName('svg')[0];
                saveSvgAsPng(map, 'snapshot-' + chart + '.png');
              }
              else {
                const canvas = document.getElementById(chart);
                canvas.toBlob(function (blob) {
                  saveAs(blob, 'snapshot-' + chart + '.png');
                });
              }
            };
          }
        }

      });

    }
  };

})(jQuery);
